/**
 * ---------maintenance history-------------
 * 2019.5.22 By Bowen Li: make the right order for standard filter items
 * 14/04/2022 By Marcus Zhao add mapChange mapConfig for map filter change.
 */
import { Subject } from 'rxjs';

export enum TileFilterEventType {
    change,
    mapChange,
}

export class TileFilterConfig {
    config: any[];
    mapConfig;
    events$: Subject<{ type: TileFilterEventType, payload: any[] | any }>;
    constructor() {
        this.events$ = new Subject();
        this.config = [];
    }
}

export const StandardFilterItems: Array<{ text: string, value: string, type: string, hide?: boolean }> = [
    { text: 'Display Date', value: 'DisplayDate', type: 'standard' },
    { text: 'Priority', value: 'Priority', type: 'standard' },
    { text: 'Sentiment', value: 'Sentiment', type: 'standard' },
    { text: 'Source', value: 'Source', type: 'standard' },
    { text: 'Subject', value: 'Subject', type: 'standard' },
    { text: 'Submitted Date', value: 'SubmittedDate', type: 'standard' },
    { text: 'Submitter', value: 'Submitter', type: 'standard' },
    { text: 'Team', value: 'Team', type: 'standard' },
];

// Entity filter for note type column groups
export const EntitiesFilter = { text: 'Entities', value: 'EntryEntity', type: 'standard' };

export const StartDateFilter = {
    name: 'Start Date',
    id: 'DisplayDate',
    dataType: 'date'
};
